const eventName = "ps-step3-form-request-current-doc";
let nextListenerId = 0;
let activeListenerId = 0;

export const awaitRequestImpl = function (doc) {
  return function (onError, onSuccess) {
    const listenerId = nextListenerId + 1;
    nextListenerId = listenerId;
    activeListenerId = listenerId;
    let completed = false;
    let cleanupTimer = undefined;

    const isActiveListener = function () {
      return activeListenerId === listenerId;
    };

    const cleanup = function () {
      if (cleanupTimer !== undefined) {
        window.clearTimeout(cleanupTimer);
        cleanupTimer = undefined;
      }
      if (isActiveListener()) {
        activeListenerId = 0;
      }
      window.removeEventListener(eventName, handler);
    };

    const cleanupSoon = function () {
      if (cleanupTimer === undefined) {
        // Keep this listener available until the next browser turn. Several
        // static form widgets can ask for the current document at once, before
        // App.Runtime has installed the replacement listener.
        cleanupTimer = window.setTimeout(cleanup, 0);
      }
    };

    const handler = function (ev) {
      // A newer App.Runtime subscription may be active before this delayed
      // listener is removed. In that case this older listener must stay quiet.
      if (!isActiveListener()) {
        return;
      }
      try {
        if (ev.detail && typeof ev.detail.callback === "function") {
          ev.detail.callback(doc);
        }
        if (!completed) {
          onSuccess({});
          completed = true;
        }
        cleanupSoon();
      } catch (err) {
        cleanup();
        if (!completed) {
          completed = true;
          onError(err);
        }
      }
    };

    window.addEventListener(eventName, handler);

    return function (_cancelError, _onCancelerError, onCancelerSuccess) {
      cleanup();
      onCancelerSuccess();
    };
  };
};
